import { APIDirectory, HTTP } from "../../rest";

export const SIGNUP_IN_PROGRESS = "SIGNUP_IN_PROGRESS";

export const SIGNUP_COMPLETE = "SIGNUP_COMPLETE";


// export const CHANGE_PASSWORD_COMPLETE = "CHANGE_PASSWORD_COMPLETE";

/**
 * SIGN UP is triggered
 */
export const signUpInProgress = () => {
  return {
    type: SIGNUP_IN_PROGRESS
  };
};

/**
 * SIGN UP is completed
 * @param {*} data -- SIGN UP items
 */

export const signUpComplete = data => {
  return {
    type: SIGNUP_COMPLETE,
    data: data
  };
};

export const signUp = userData => {
  return async dispatch => {
    try {
      dispatch(signUpInProgress());
      let signUpResult = await HTTP.POST(APIDirectory.SignUpURL(), userData);
      dispatch(signUpComplete(signUpResult));
      return signUpResult;
    } catch (error) {
      throw error
    }
  };
};


export const changePassword = async (emailId) => {
  try {
    let url = APIDirectory.sendEmailForgotPassword(emailId);
    let response = await HTTP.GET(url)
    return response;
  } catch (error) {
    throw error
  }
};